import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getLog } from "../../redux/actions/log.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from "antd";
import { logColumns, adminDepartmentColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
import { addAdminDepartment, deleteAdminDepartment, getAllUserDepartment, updateAdminDepartment } from "../../redux/actions/UserDepartment.action";

const { TabPane } = Tabs;
export default function AdminDepartment({ token, userRights }) {
  TabTitle("Admin Department")
  const menuId = ReadCookie("menuId");
  const dCompanyId = ReadCookie("defaultCompany");
  const adminDepartmentNameInput = useRef(null);
  const [form] = Form.useForm();
  const [adminDepartmentObj, setAdminDepartmentObj] = useState(null);
  const dispatch = useDispatch();
  const { log, userDepartment } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [adminDepartmentName, setAdminDepartmentName] = useState("");
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");

  useEffect(() => {
    dispatch(getAllUserDepartment(token));
    dispatch(getLog(token, { admin_user_department: "admin_user_department" }));
  }, [token]);

  useLayoutEffect(() => {
    if (!userRights.can_add) {
      setFormState("table");
    }
  }, []);

  useEffect(() => {
    if (adminDepartmentObj) {
      setFormState("view");
      form.setFieldsValue({
        id: adminDepartmentObj.department_id,
        adminDepartment: adminDepartmentObj.department_name,
        active: adminDepartmentObj.is_active,
      });
      setAdminDepartmentName(adminDepartmentObj.department_name);
      setCheck(adminDepartmentObj.is_active);
    }
  }, [adminDepartmentObj]);

  useEffect(() => {
    if (adminDepartmentName === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [adminDepartmentName]);

  const formSave = () => {
    if (formState === "add") {
      dispatch(addAdminDepartment(token, { adminDepartmentName, check }, menuId)).then(
        (res) => {
          if (res.type === "ADD_ADMIN_DEPARTMENT_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_ADMIN_DEPARTMENT_SUCCESS") {
            notification(
              "success",
              "Admin Department Created",
              "Admin Department Created Successfully!"
            );
            form.setFieldsValue({
              adminDepartment: "",
            });
            setFormState("");
            setAdminDepartmentName("");
            setAdminDepartmentObj(null);
          }
          dispatch(getAllUserDepartment(token))
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateAdminDepartment(
          token,
          { adminDepartmentName, check },
          adminDepartmentObj.department_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_ADMIN_DEPARTMENT_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_ADMIN_DEPARTMENT_SUCCESS") {
          notification(
            "success",
            "Admin Department Updated",
            "Record Updated Successfully"
          );
        }
        dispatch(getAllUserDepartment(token))
      });
    }
  };

  const handleDelete = () => {
    if (adminDepartmentObj) {
      dispatch(deleteAdminDepartment(token, adminDepartmentObj.department_id)).then(
        (res) => {
          if (res.type === "DELETE_ADMIN_DEPARTMENT_SUCCESS") {
            notification(
              "success",
              "Admin Department Deleted",
              "Admin Department Deleted Successfully!"
            );
          }
          if (res.type === "DELETE_ADMIN_DEPARTMENT_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            adminDepartment: "",
          });
          setAdminDepartmentName("");
          setAdminDepartmentObj(null);
          setFormState("");
          dispatch(getAllUserDepartment(token))
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
      dispatch(getOneDefaultCompany(token, dCompanyId));
      adminDepartmentNameInput.current.focus();
      form.setFieldsValue({
        adminDepartment: "",
      });
      setCheck(true);
      setAdminDepartmentName("");
    }
  }, [formState]);

  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Department"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="adminDepartment"
                      adminDepartmentObj={setAdminDepartmentObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={userDepartment?.payload?.data}
                      col={adminDepartmentColumns}
                      paginate
                      load={userDepartment.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {adminDepartmentObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="ID"
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                              name="id"
                              initialValue={form.getFieldValue().id}
                            >
                              <Input
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="Department Name"
                            name="adminDepartment"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().adminDepartment}
                            rules={[
                              {
                                required: true,
                                message: "Department Name is required",
                              },
                            ]}
                          >
                            <Input
                              size="small"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              ref={adminDepartmentNameInput}
                              onChange={(e) =>
                                setAdminDepartmentName(e.target.value)
                              }
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>

                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                      >
                        <TabPane tab="Log Info" key="1">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
